import { Navigate } from 'react-router';

import { ROUTES } from '~shared/config/routes';
import { Loader } from '~shared/ui/loader';

import { isAuthorisedAtom } from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue } from 'jotai';

import { useUserInfo } from '../api';
import { getDefaultRouteByRole } from '../lib';

export const RootRedirect = () => {
  const isAuthorised = useAtomValue(isAuthorisedAtom);
  const userInfoQuery = useUserInfo({
    enabled: isAuthorised,
  });

  if (!isAuthorised) {
    return <Navigate to={ROUTES.login} replace />;
  }

  if (userInfoQuery.data && isAuthorised) {
    return <Navigate to={getDefaultRouteByRole(userInfoQuery.data)} replace />;
  }

  return <Loader />;
};
